import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { editCostCenter } from 'RestAPIs/admin';

import showError from 'components/shared/showError';

const useEditPlanUnit = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(editCostCenter, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['costCenters', 'list']
      });
    },
    onError: (error) => showError(error as AxiosError)
  });

  return { mutateAsync, isLoading };
};

export default useEditPlanUnit;
